exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.function-status[data-v-6578d8e7] {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\n/* 旋转 */\n.my_animation[data-v-6578d8e7] {\n  -webkit-animation: rotating 2s linear infinite;\n          animation: rotating 2s linear infinite;\n}", "", {"version":3,"sources":["C:/Users/Nokia/Documents/code/prod/mcFrontend2/src/components/common/tabs/tabs_task_list/tab_task_status.vue"],"names":[],"mappings":";AAAA;EACE,oBAAa;MAAb,qBAAa;UAAb,aAAa;CACd;;AAED,QAAQ;AAER;EACE,+CAAuC;UAAvC,uCAAuC;CACxC","file":"tab_task_status.vue","sourcesContent":[".function-status {\n  flex-grow: 1;\n}\n\n/* 旋转 */\n\n.my_animation {\n  animation: rotating 2s linear infinite;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6578d8e7","scoped":true,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/tabs/tabs_task_list/tab_task_status.vue
// module id = i0NC
// module chunks = 1